import { Component, Input, OnInit } from '@angular/core';
import { ConferenceViewModel, OrganizationViewModel, PageElementViewModel } from 'src/app/_models/generatedModels';
import { OrganizationService } from 'src/app/_services/generatedServices';

@Component({
  selector: 'bxl-conference-list',
  templateUrl: 'conference-list.component.html',
})
export class ConferenceListComponent implements OnInit {
  initialized = false;
  @Input() conference: ConferenceViewModel;
  @Input() element: PageElementViewModel;
  @Input() organization: OrganizationViewModel;
  conferences: ConferenceViewModel[];

  constructor(private orgService: OrganizationService) {}

  ngOnInit(): void {
    console.log('here');
    this.orgService.getAllConferencesForOrg(this.organization.id.toString()).subscribe((conferences) => {
      this.conferences = conferences.filter((x) => x.published);
      this.initialized = true;
    });
  }
}
